import { IS_PROD } from 'shared/helpers/env';

const DEVTOOLS_ENABLED = !IS_PROD;

/**
 * Returns whether devtools are currently active.
 * Devtools are active in non-production environments AND when the URL has the `?dev` parameter.
 */
export function isDevtoolsActive(locationSearch?: string): boolean {
  if (!DEVTOOLS_ENABLED) {
    return false;
  }

  const search = locationSearch ?? window.location.search;
  const searchParams = new URLSearchParams(search);
  return searchParams.has('dev');
}
